import { createRoot } from "react-dom/client";
import { StoreProvider } from "../app/storeProvider";
import React from "react";
import SubscriptionPage from "../app/(general-header)/subscription/page";

const root = createRoot(document.getElementById("subscription-page-container") as HTMLElement);

root.render(
  <React.StrictMode>
    <StoreProvider>
      <SubscriptionPage />
    </StoreProvider>
  </React.StrictMode>
);
